!function() {
  "use strict";
  customElements.get("load-more") || customElements.define("load-more", class extends HTMLElement {
    button=this.querySelector("a");
    buttonText=this.button.textContent;
    section=this.dataset.section || "";
    selectors=[ "[data-grid]", "[data-pagination]" ];
    constructor() {
      super();
    }
    loadMore(t) {
      t.preventDefault(), t.stopPropagation(), this.classList.add("opacity-50", "cursor-wait"), 
      window.strings.loading && (this.button.textContent = window.strings.loading), this.selectors.push(`[data-${t.target.dataset.mode || "next"}]`);
      const e = t.target.dataset.mode?.includes("prev") ? "afterbegin" : "beforeend", n = document.querySelector(`#shopify-section-${this.section}`) || document;
      fetch(`${t.target.href}&section_id=${this.section}`).then((t => t.text())).then((o => {
        const a = (new DOMParser).parseFromString(o, "text/html");
        this.selectors.forEach(((o, s) => {
          const i = n.querySelector(o), r = a.querySelector(o);
          i && (r ? o.toLowerCase().includes("grid") ? i.insertAdjacentHTML(e, r.innerHTML) : i.innerHTML = r.innerHTML : i.parentNode.removeChild(i)), 
          history.pushState({}, "", t.target.href), this.button.textContent = this.buttonText;
        }));
        let s = location.search.match(/page=([0-9]+)/);
        s = s || 1;
        let i = t.target.href.match(/page=([0-9]+)/);
        i = i || 1, window.dataLayer = window.dataLayer || [], window.dataLayer.push({
          event: "list_page_pagination_click",
          click_action: t.target.dataset.mode?.includes("prev") ? "previous" : "next",
          current_page_number: s,
          destination_page_number: i
        });
      })).catch((t => {
        console.warn(t);
      })).finally((() => {
        this.classList.remove("opacity-50", "cursor-wait");
      }));
    }
    connectedCallback() {
      this.button?.addEventListener("click", this.loadMore.bind(this));
    }
  });
}();